import { Component, Input } from '@angular/core';
import { CollegeScorecardAPIService } from '../college-scorecard.service';
import { TerritoryCardService } from '../../territoryCard/territory-card.service';
import { ObjectCarouselComponent } from "../../base/objectCarousel/object-carousel.component";

@Component({
	selector: 'app-college-scorecard-fields-of-study',
	templateUrl: "../../base/objectCarousel/object-carousel.component.html",
	standalone: false
})
export class CollegeScorecardFieldsOfStudyComponent extends ObjectCarouselComponent  {
	@Input() schoolId: string = "";

	constructor(
		private tcs: TerritoryCardService,
		private cscAPI: CollegeScorecardAPIService
	) {
		super();
		this.componentName = "College Scorecard Fields of Study";
		this.objectName = "Fields of Study";
	}

	protected override downloadData(): void {
		if (this.retrievingData || this.downloading || this.downloadComplete || this.schoolId === "") {
			return;
		}
		this.downloading = true;
		this.retrievingData = this.offset === 0 ? true : false;

		this.cscAPI.getFieldsOFStudy(this.schoolId).subscribe(
			response => {
				if (this.offset === 0) {
					if (response.length > 0) {
						this.hasData.emit(true);
					}
					else {
						this.hasData.emit(false);
						this.noDataWidget = true;
					}
				}
				if (response.length > 0) {
					this.offset += this.limit;
					for (let i = 0; i < response.length; i++) {
						super.addObjectItem(this.tcs.normalizeFieldsofStudy(response[i]));
					}
					this.noDataWidget = false;
					if (response.length < this.limit) {
						this.downloadComplete = true;
					}
				}
				else {
					this.downloadComplete = true;
				}

				this.downloading = false;
				this.retrievingData = false;
			},
			error => {
				console.log(error);
				this.retrievingData = false;
				this.downloading = false;
				if (this.offset === 0) {
					this.hasData.emit(false);
					this.noDataWidget = true;
				}
			}
		);
	}
}
